// extracted by mini-css-extract-plugin
export default {"wrapper":"stickyScrollShell_wrapper__RJ-V3","shell":"stickyScrollShell_shell__7bXH7","proxy":"stickyScrollShell_proxy__W0sJA","proxyTrack":"stickyScrollShell_proxyTrack__JHKg5"};